import { render, staticRenderFns } from "./JobCategoryAdmin.vue?vue&type=template&id=d7d96b4a&scoped=true"
import script from "./JobCategoryAdmin.vue?vue&type=script&lang=js"
export * from "./JobCategoryAdmin.vue?vue&type=script&lang=js"
import style0 from "./JobCategoryAdmin.vue?vue&type=style&index=0&id=d7d96b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d96b4a",
  null
  
)

export default component.exports